var _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "svg9039933901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.334 16.667)",
    id: "ss9039933901_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 29.166 C 0 15.417 0 8.543 4.271 4.271 C 8.543 0 15.417 0 29.167 0 L 33.333 0 C 47.083 0 53.957 0 58.229 4.271 C 62.5 8.542 62.5 15.417 62.5 29.166 L 62.5 37.5 C 62.5 51.249 62.5 58.123 58.229 62.395 C 53.957 66.666 47.082 66.666 33.333 66.666 L 29.167 66.666 C 15.417 66.666 8.543 66.666 4.271 62.396 C 0 58.123 0 51.249 0 37.5 Z",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.5 20.441 L 63.025 20.008 C 71.84 12.734 76.248 9.097 79.791 10.853 C 83.333 12.609 83.333 18.431 83.333 30.075 L 83.333 36.591 C 83.333 48.235 83.333 54.057 79.791 55.813 C 76.248 57.569 71.841 53.933 63.025 46.658 L 62.5 46.225",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.582 29.166 C 43.034 29.166 45.832 26.368 45.832 22.916 C 45.832 19.464 43.034 16.666 39.582 16.666 C 36.13 16.666 33.332 19.464 33.332 22.916 C 33.332 26.368 36.13 29.166 39.582 29.166 Z",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg9039933901"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.deec07494f59dff7721346a9cda33ba6.svg";
export { ForwardRef as ReactComponent };